import React from 'react';
import { Form, Checkbox, Input, notification } from 'antd';
import { observer } from 'mobx-react';
import moment from 'moment';

import AddEditStore from './store';
import { Button } from 'semantic-ui-react';
import customFetch from '../../../utils/customFetch';
import { action } from 'mobx';
// import router from '../../../stores/router';
import { formatDate } from '../../../utils/functions';
// import { toJS } from 'mobx';

@observer
class LoginInformation extends React.Component {
  notifyEnable = () => {
    AddEditStore.toggleModal(true, {
      modalType: 'notification',
      message: 'This user is not yet enabled for login. Enable Login first.',
    })();
  };

  handleEditUser = () => {
    const { userId } = AddEditStore;
    customFetch('/Manager/GetUserById', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId }),
    }).then(
      action(data => {
        AddEditStore.dataUser = data;
        AddEditStore.toggleModal(true, { modalType: 'editUser' })();
      }),
    );
  };

  handleUnlockUser = () => {
    const { userId } = AddEditStore;
    customFetch('/manager/unlockUser', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ userId }),
    }).then(() => {
      notification.destroy();
      notification.success({
        message: 'Success',
        description: `User has been unlocked`,
        duration: 5,
      });
    });
  };

  handleResetPassword = () => {
    const { userId, Id } = AddEditStore;
    AddEditStore.toggleModal(false, {})();
    setTimeout(() => {
      customFetch('/Manager/ResetPassword', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ userId, cmId: Id }),
      }).then(res => {
        AddEditStore.toggleModal(true, {
          modalType: 'notification',
          message: `Generated password: ${res.result}`,
        })();
      });
    });
  };

  handleResendLoginInformation = () => {
    const { userId, Id } = AddEditStore;
    customFetch('/Manager/ResendLoginInformation', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ userId, cmId: Id }),
    }).then(() => {
      notification.destroy();
      notification.success({
        message: 'Success',
        description: `Resend login Information: Successfully!!`,
        duration: 5,
      });
    });
  };

  render() {
    const { CMInfo } = AddEditStore;
    return (
      <Form name="login-information">
        <div className="fluid-field checkbox-field">
          <Checkbox
            checked={CMInfo.LoginRequired}
            onChange={AddEditStore.handleChecked('LoginRequired')}
          >
            Login required
          </Checkbox>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox
            checked={CMInfo.EnableLogin}
            onChange={AddEditStore.handleChecked('EnableLogin')}
          >
            Enable Login
            {CMInfo.EnableLoginDate
              ? ' (' +
                moment(
                  formatDate(CMInfo.EnableLoginDate, true),
                  'DD MMM YYYY, HH:mm',
                ).format('DD/MM/YYYY')
              : ''}
            {CMInfo.EnableLoginBy ? ' - ' + CMInfo.EnableLoginBy + ')' : ''}
          </Checkbox>
          <span className="note">
            By enabling login, an activation email will be sent to the case
            manager's business email for access. The password will be set by the
            case manager. We do not keep their password information.
          </span>
        </div>
        <Form.Item label="Username">
          <Input size="large" value={CMInfo.Username} disabled />
        </Form.Item>
        {CMInfo.Id !== 0 && (
          <div className="fluid-field">
            <Button
              color="blue"
              onClick={
                !CMInfo.EnableLogin ? this.notifyEnable : this.handleEditUser
              }
            >
              Edit Username
            </Button>
            <Button
              color="blue"
              onClick={
                !CMInfo.EnableLogin ? this.notifyEnable : this.handleUnlockUser
              }
            >
              Unlock User
            </Button>
            <Button
              color="blue"
              onClick={
                !CMInfo.EnableLogin
                  ? this.notifyEnable
                  : AddEditStore.toggleModal(true, {
                      modalType: 'confirm',
                      message: `Do you want to reset password for user ${CMInfo.FirstName} ${CMInfo.LastName}? New password will be sent to the user automatically.`,
                      onOk: this.handleResetPassword,
                    })
              }
            >
              Reset Password
            </Button>
            <Button
              color="blue"
              onClick={
                !CMInfo.EnableLogin
                  ? this.notifyEnable
                  : this.handleResendLoginInformation
              }
            >
              Resend Login Information
            </Button>
            {CMInfo.Username && (
              <Button
                color="blue"
                onClick={() =>
                  AddEditStore.toggleModal(true, {
                    modalType: 'passwordRsHistory',
                  })()
                }
              >
                Password Reset History
              </Button>
            )}
          </div>
        )}
      </Form>
    );
  }
}

export default LoginInformation;
